
var app = angular.module('directives.paymentCheck', []);

require('./directives/paymentCheck.js');
require('./stylesheets/paymentCheck.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentCheck/index.js
 ** module id = 194
 ** module chunks = 1
 **/